// SPDX-License-Identifier: AGPL-3.0-or-later

import Messages from '@app/features/messaging/state/MessagingMessages';

export function handleResumed(): void {
	Messages.handleResumed();
}
